module.exports = __webpack_public_path__ + "img/business-building-gray.bcb8fa72.png";